import React from 'react';
import styled from 'styled-components';
import CarIconSvg from '../assets/hotels/details/carIcon.svg';

const CarIcon = styled(CarIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill};
`;

export default CarIcon;
